import {
  evaluateCategoryHashWithAll,
  IEvaluateCategoryKeysWithAll,
} from "const";
import { FC } from "react";

type Props = {
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  current: IEvaluateCategoryKeysWithAll;
};
const CategorySelector: FC<Props> = ({ onChange, current }) => {
  return (
    <div className="select mr-2">
      <select onChange={onChange} value={current}>
        {(
          Object.keys(
            evaluateCategoryHashWithAll
          ) as (keyof typeof evaluateCategoryHashWithAll)[]
        ).map((ck) => (
          <option key={ck} value={ck}>
            {evaluateCategoryHashWithAll[ck]}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CategorySelector;
